import React from "react";
import { Navigate } from "react-router-dom";
import type { SweetAlertOptions } from "sweetalert2";
import { DASHBOARD_ROUTE, SIGNIN_ROUTE } from "../constants/RoutePaths";

interface RouteGuardProps {
  children: React.ReactNode;
}

export function PublicRoute({ children }: RouteGuardProps): React.ReactElement {
  const token = localStorage.getItem("AUTH_TOKEN");
  return !token ? <>{children}</> : <Navigate to={DASHBOARD_ROUTE} />;
}

export function PrivateRoute({ children }: RouteGuardProps): React.ReactElement {
  const token = localStorage.getItem("AUTH_TOKEN");
  const location = window.location.href;
  return token ? <>{children}</> : <Navigate to={SIGNIN_ROUTE} state={location} />;
}

export interface AuthHeader {
  Authorization: string | null;
  [key: string]: string | null;
}

export function authHeader(): AuthHeader {
  const token = localStorage.getItem("AUTH_TOKEN");
  return { Authorization: token };
}

// Note: `type` is the legacy sweetalert v1 API field; sweetalert2 renamed this to `icon`.
// These configs are passed straight into `Swal.fire(...)`. The runtime shape is unchanged;
// we widen the return type to `SweetAlertOptions` so Swal accepts the call (it still
// recognises the legacy `type` field for backward compatibility).
export type AlertToastConfig = SweetAlertOptions;

export const getAlertToast = (type = "success", text = "", timer = 5000): AlertToastConfig =>
  ({
    toast: true,
    position: "bottom",
    titleText: text,
    type: type,
    showConfirmButton: false,
    timer: timer,
  }) as SweetAlertOptions;

export type AlertConfig = SweetAlertOptions;

export const getAlert = (type = "success", text = ""): AlertConfig =>
  ({
    position: "center",
    type: type,
    text: text,
    customClass: {
      confirmButton: "btn-shadow btn btn-primary btn-lg",
    },
    buttonsStyling: false,
    confirmButtonColor: "#000",
  }) as SweetAlertOptions;
